import { createAction } from "@reduxjs/toolkit";
import { City, PaginationOptions } from "../../interfaces";
import * as CityActionTypes from "./types";

export const loadAllCity = createAction<Partial<PaginationOptions>>(
  CityActionTypes.fetch_paginated_cities_saga
);
export const loadCityById = createAction<string>(
  CityActionTypes.fetch_city_by_id_saga
);
export const createCity = createAction<Omit<City, "uid">>(
  CityActionTypes.create_new_city_saga
);
export const updateCity = createAction<City>(CityActionTypes.update_city_saga);
export const deleteCityById = createAction<string>(
  CityActionTypes.delete_city_saga
);
export const createCities = createAction<Omit<City, "uid">>(
  CityActionTypes.create_new_city_saga
);
